import {
  BaseTextField,
  type BaseTextFieldProps,
  type TextFieldState,
} from "./text-field";

export const formatByMask = (
  value: string,
  mask: string,
  countryCode: string,
): string => {
  const normalizedValue = value.startsWith("+")
    ? `+${value.slice(1).replace(/\D/g, "")}`
    : countryCode + value.replace(/\D/g, "");

  const digitsOnly = normalizedValue.replace(/\D/g, "");
  const countryCodeDigits = countryCode.replace("+", "");
  const maxDigits = mask.split("").filter((c) => c === "#").length;
  const maxTotalDigits = countryCodeDigits.length + maxDigits;
  const limitedDigitsOnly = digitsOnly.slice(0, maxTotalDigits);

  const startsWithCountryCode = limitedDigitsOnly.startsWith(countryCodeDigits);

  const rawDigits = startsWithCountryCode
    ? limitedDigitsOnly.slice(countryCodeDigits.length)
    : limitedDigitsOnly;

  const limitedRawDigits = rawDigits.slice(0, maxDigits);

  let result = "";
  let digitIndex = 0;

  for (const char of mask) {
    const isDigitExpected = char === "#";
    const hasMoreDigits = digitIndex < limitedRawDigits.length;

    if (isDigitExpected) {
      if (hasMoreDigits) {
        result += limitedRawDigits[digitIndex++];
      } else {
        break;
      }
    } else {
      if (hasMoreDigits) {
        result += char;
      } else {
        break;
      }
    }
  }

  return result;
};

type PhoneFieldState = TextFieldState;

export const PhoneField = ({
  field,
  pattern,
  countryCode,
  ...props
}: BaseTextFieldProps<PhoneFieldState> & {
  pattern: string;
  unmask?: boolean;
  countryCode: string;
}) => {
  const maxDigits = pattern.split("").filter((c) => c === "#").length;
  const countryCodeDigits = countryCode.replace("+", "");
  const maxTotalDigits = countryCodeDigits.length + maxDigits;

  return (
    <BaseTextField
      type="tel"
      inputMode="tel"
      autoComplete="tel"
      {...props}
      placeholder={pattern.replaceAll("#", "_")}
      field={{
        ...field,
        value: formatByMask(field.value, pattern, countryCode),
        onValueChanged: (input) => {
          const normalized = normalizePhoneInput(input, countryCode);
          const digits = normalized.replace(/\D/g, "");
          const limitedDigits = digits.slice(0, maxTotalDigits);
          const finalValue = `+${limitedDigits}`;
          field.onChange({ ...field, value: finalValue });
        },
      }}
      onPaste={(event) => {
        const pasteData = event.clipboardData.getData("Text");
        const normalized = normalizePhoneInput(pasteData, countryCode);
        event.preventDefault();
        field.onChange({ ...field, value: normalized });
      }}
    />
  );
};

const normalizePhoneInput = (rawInput: string, countryCode: string): string => {
  const cleaned = rawInput.replace(/[^\d+]/g, "");

  let digits = cleaned.startsWith("+")
    ? `+${cleaned.slice(1).replace(/\D/g, "")}`
    : countryCode + cleaned.replace(/\D/g, "");

  //Кейс только для вставки, и автозаполнения
  if (
    ((countryCode === "+7" && digits.startsWith("+78")) ||
      (countryCode === "+40" && digits.startsWith("+400"))) &&
    //Минимальный размер для очистки номера в маске 5 цифр, т.е +4040
    digits.length > 5
  ) {
    digits = `${countryCode}${digits.slice(countryCode.length + 1)}`;
  }

  return digits;
};
